"use client";

import { TopOfPageContentWrapper } from "@faire/deprecated-retailer-visitor-shared/components/App/TopOfPageContent/Wrapper";
import { LoginSection } from "@faire/deprecated-retailer-visitor-shared/components/Header/desktop/LoginSection";
import { HeaderCart } from "@faire/deprecated-retailer-visitor-shared/components/Header/HeaderCart";
import { OpenWithFaireBreadcrumbs } from "@faire/deprecated-retailer-visitor-shared/components/Header/HeaderOpenWithFaire/__internal__/OpenWithFaireBreadcrumbs";
import { HeaderMobileSignUp } from "@faire/deprecated-retailer-visitor-shared/components/Header/mobile/HeaderMobileSignUp";
import { HeaderContainer } from "@faire/deprecated-retailer-visitor-shared/components/Header/styled";
import { useCanAddToCart } from "@faire/deprecated-retailer-visitor-shared/lib/useCanAddToCart";
import { Row } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import React from "react";
import styled from "styled-components";

export const HeaderOpenWithFaire = () => {
  const { isDesktopAndAbove } = useViewport();

  return (
    <TopOfPageContentWrapper>
      <HeaderContainer>
        <Wrapper>
          <OpenWithFaireBreadcrumbs />
          <HeaderItems align="center">
            {isDesktopAndAbove ? <LoginSection /> : <HeaderMobileSignUp />}
            <CartSection />
          </HeaderItems>
        </Wrapper>
      </HeaderContainer>
    </TopOfPageContentWrapper>
  );
};

const CartSection = React.memo(() => {
  const canAddToCart = useCanAddToCart();
  return canAddToCart ? (
    <>
      <HeaderCart dataTestId="headerCartButton" />
      <Spacer width="3x" />
    </>
  ) : null;
});

const Wrapper = styled(Row)
  .attrs({ justify: "space-between" })
  .attrs({ align: "center" })`
  width: 100%;
`;

const HeaderItems = styled(Row)`
  min-height: 60px;
`;
